// extracted by css-extract-rspack-plugin
export default {"backdrop":"src-pages-projects-SlidePreviewModal-module__backdrop-WCrHcL","panel":"src-pages-projects-SlidePreviewModal-module__panel-lNerCY","header":"src-pages-projects-SlidePreviewModal-module__header-ZGJokX","title":"src-pages-projects-SlidePreviewModal-module__title-DLAQvD","closeBtn":"src-pages-projects-SlidePreviewModal-module__closeBtn-ZszExX","viewerWrap":"src-pages-projects-SlidePreviewModal-module__viewerWrap-ac5Zq9"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"backdrop\":\"src-pages-projects-SlidePreviewModal-module__backdrop-WCrHcL\",\"panel\":\"src-pages-projects-SlidePreviewModal-module__panel-lNerCY\",\"header\":\"src-pages-projects-SlidePreviewModal-module__header-ZGJokX\",\"title\":\"src-pages-projects-SlidePreviewModal-module__title-DLAQvD\",\"closeBtn\":\"src-pages-projects-SlidePreviewModal-module__closeBtn-ZszExX\",\"viewerWrap\":\"src-pages-projects-SlidePreviewModal-module__viewerWrap-ac5Zq9\"}";
        // 1788963437249
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  